// extracted by mini-css-extract-plugin
module.exports = {"plainText":"plain-text-module--plain-text--3ym9a","plainTextVideoBelow":"plain-text-module--plain-text--videoBelow--3w3uU"};